export const AppCode = {
  LOGEMENTS: "logement",
  HOTEL: "hotel",
  CAMPING: "camping",
  ETABLISSEMENTSSPORTIFS: "sport",
  // ETABLISSEMENTSSPORTIFS: "etablissementssportifs",
  ETABLISSEMENTSSCOLAIRES: "etablissements_scolaires",
  CASERNE: "caserne",
  ETABLISSEMENTDESANTE: "etablissement_de_sante",
  RESTAURANT: "restaurant",
  AUTRETERTIAIRE: "autre_tertiaire",
  // PROCESSUSINDUSTRIEL: "processus_industriel",
  PROCESSUSINDUSTRIEL: "indus",
  SANTE: "sante",
};

export const SubAppCode = {
  LOGEMENTSPRIVES: "prives",
  LOGEMENTSSOCIAUX: "sociaux",
  RESIDENCESSENIORS: "seniors",
  RESIDENCESETUDIANTE: "etudiant",
  FOYERDEJEUNESTRAVAILLEURS: "travailleur",
  CAMPING: "camping",
  AFFAIRES: "affaires",
  TOURISME: "tourisme",
  MONTAGNE: "montagne",
  STADEFOOTBALL: "football",
  STADERUGBY: "rugby",
  GYMNASE: "gymnase",
  PISCINE: "piscine",
  SALLEDEFITNESS: "multisport",
  CASERNE: "caserne",
  INTERNAT: "internat",
  HOPITALCLINIQUEDOUCHES: "hopital",
  EHPAD: "ehpad",
  TRADITIONNEL: "traditionnel",
  GASTRONOMIQUE: "gastronomique",
  RAPIDE: "rapide",
  COLLECTIF: "collectif",
  VESTIAIREDENTREPRISE: "vestiaire",
  STATIONDELAVAGE: "station",
  PROCESSUSINDUSTRIEL: "indus",
  isValid: (subApp: string) => {
    return (
      SubAppCode.LOGEMENTSPRIVES === subApp ||
      SubAppCode.LOGEMENTSSOCIAUX === subApp ||
      SubAppCode.RESIDENCESSENIORS === subApp ||
      SubAppCode.RESIDENCESETUDIANTE === subApp ||
      SubAppCode.FOYERDEJEUNESTRAVAILLEURS === subApp ||
      SubAppCode.CAMPING === subApp ||
      SubAppCode.AFFAIRES === subApp ||
      SubAppCode.TOURISME === subApp ||
      SubAppCode.STADEFOOTBALL === subApp ||
      SubAppCode.STADERUGBY === subApp ||
      SubAppCode.GYMNASE === subApp ||
      SubAppCode.PISCINE === subApp ||
      SubAppCode.SALLEDEFITNESS === subApp ||
      SubAppCode.MONTAGNE === subApp ||
      SubAppCode.TRADITIONNEL === subApp ||
      SubAppCode.GASTRONOMIQUE === subApp ||
      SubAppCode.RAPIDE === subApp ||
      SubAppCode.COLLECTIF === subApp ||
      SubAppCode.CASERNE === subApp ||
      SubAppCode.VESTIAIREDENTREPRISE === subApp ||
      SubAppCode.STATIONDELAVAGE === subApp ||
      SubAppCode.EHPAD === subApp ||
      SubAppCode.HOPITALCLINIQUEDOUCHES === subApp ||
      SubAppCode.INTERNAT === subApp ||
      SubAppCode.PROCESSUSINDUSTRIEL === subApp
    );
  },
} as const;

export const SystemCode = {
  ECHANGEUR_A_PLAQUES_BALLONS_PRIMAIRES: "hygiatherm",
  ECHANGEUR_A_PLAQUES: "echangeur",
  BALLONS_ECS_PREPARATEURS: "serpentin",
  ACCUMULATEURS_GAZ_BALLONS_ECS: "sanigaz",
  ACCUMULATEURS_GAZ_BALLONS_ECS_HMWM: "hmwm",
  BALLONS_ECS_TANK_IN_TANK: "tankintank",
  ECHANGEUR_BALLONS_ECS: "echangeur_ballon",
  BALLONS_ELECTRIQUES: "electrique",
  isValid: (systemCode: string) => {
    return (
      SystemCode.ECHANGEUR_A_PLAQUES === systemCode ||
      SystemCode.ECHANGEUR_BALLONS_ECS === systemCode ||
      SystemCode.BALLONS_ELECTRIQUES === systemCode ||
      SystemCode.ECHANGEUR_A_PLAQUES_BALLONS_PRIMAIRES === systemCode ||
      SystemCode.ACCUMULATEURS_GAZ_BALLONS_ECS === systemCode ||
      SystemCode.ACCUMULATEURS_GAZ_BALLONS_ECS_HMWM === systemCode ||
      SystemCode.BALLONS_ECS_TANK_IN_TANK === systemCode ||
      SystemCode.BALLONS_ECS_PREPARATEURS === systemCode
    );
  },
};

export const ExpertModeTypes = {
  APPARTEMENT: "appartement",
  BATIMENT: "batiment",
  LOGEMENT: "logement",
};
